const doc = [({"da":({"js":({"admin":({"invoices":({"show":({"show_invoice":"Vis faktura %{id}", "show_logs_for_invoice":"Logs for faktura %{id}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;